
import {
  Vuetify,
  VApp,
  VAlert,
  VBtn,
  VBtnToggle,
  VCard,
  VCheckbox,
  VDialog,
  VDivider,
  VIcon,
  VForm,
  VGrid,
  VMenu,
  VRadioGroup,
  VSelect,
  VStepper,
  VTabs,
  VToolbar,
  VTooltip,
  VTextField,
  VProgressCircular,
  VProgressLinear,
  /*
    VAvatar,
    VBadge,
    VBottomNav,
    VBottomSheet,
    VBreadcrumbs,
    VCarousel,
    VChip,
    VDataTable,
    VDatePicker,
      VExpansionPanel,
    VFooter,
    VList,
    VNavigationDrawer,
    VPagination,
    VParallax,
    VProgressLinear,
    VSlider,
    VSnackbar,
    VSpeedDial,
    VSubheader,
    VSwitch,
    VSystemBar,
    VTimePicker
  */
} from 'vuetify'

import Vue from 'vue'
import * as directives from 'vuetify/es5/directives'
//import 'vuetify/src/stylus/app.styl'
//________________________________________________________________________

Vue.use(Vuetify, {
  directives,
  components: {
    VApp,
    VAlert,
    VBtn,
    VBtnToggle,
    VCard,
    VCheckbox,
    VDialog,
    VDivider,
    VIcon,
    VForm,
    VGrid,
    VMenu,
    VRadioGroup,
    VSelect,
    VStepper,
    VTabs,
    VToolbar,
    VTooltip,
    VTextField,
    VProgressCircular,
    VProgressLinear,
    /*
      VAvatar,
      VBadge,
      VBottomNav,
      VBottomSheet,
      VBreadcrumbs,
      VCarousel,
      VChip,
      VDataTable,
      VDatePicker,
        VExpansionPanel,
      VFooter,
      VList,
      VNavigationDrawer,
      VPagination,
      VParallax,
      VProgressLinear,
      VSlider,
      VSnackbar,
      VSpeedDial,
      VSubheader,
      VSwitch,
      VSystemBar,
      VTimePicker
    */
  },
  theme: {
    primary: '#1d5a98',
    secondary: '#0f0f0f',
    accent: '#d7dbe2',
    info: '#1487BE',
    warning: '#FFC107',
    error: '#F44336',
    success: '#4CAF50',
  },
})
